
import { defineComponent } from "vue";
import CountdownBar from "@/components/CountdownBar.vue";
import GameInfoPoint from "@/components/GameInfoPoint.vue";
import GameWrapper from "@/components/GameWrapper.vue";
import Task from "@/data/Task";
import Countdown from "@/data/Countdown";
import type { FlyOutActionButtonOptions, GameInfo } from "@/data/types";
import { ScoreElement } from "@/data/types";
import { OPERATOR_COLLECTION } from "@/data/constants";
import { shuffleArray } from "@/helper/util";

const actionButtons: FlyOutActionButtonOptions[] = [
  {
    name: "solution1",
    alternative: "←",
    code: "ArrowLeft",
    label: "",
    clickEvent: {
      event: "commit-solution",
      value: 0,
    },
    buttonSize: "half",
    hasFlyOut: true,
    actionCounter: 0,
  },
  {
    name: "solution2",
    alternative: "→",
    code: "ArrowRight",
    label: "",
    clickEvent: {
      event: "commit-solution",
      value: 1,
    },
    buttonSize: "half",
    hasExtraBorder: true,
    hasFlyOut: true,
    actionCounter: 0,
  },
];

export default defineComponent({
  name: "SpeedSolver",

  components: {
    CountdownBar,
    GameInfoPoint,
    GameWrapper,
  },

  data() {
    return {
      actionButtons,
      gameCountdown: new Countdown(60) as Countdown,
      isGameOver: true,
      restartCounter: 0,
      results: [] as GameInfo[],
      solutions: [] as number[],
      task: new Task(2, { operators: OPERATOR_COLLECTION.FULL }) as Task,
    };
  },

  methods: {
    restart() {
      this.restartCounter += 1;
      this.gameCountdown.reset();
      this.isGameOver = false;
      this.results = [];
      this.solutions = [];
      this.nextTask();
    },

    startGameCountdown() {
      this.gameCountdown.start();
    },

    endGame() {
      this.isGameOver = true;
    },

    nextTask() {
      this.task.new();
      this.solutions = shuffleArray([
        this.task.fakeSolution,
        this.task.solution,
      ]);
      this.actionButtons[0].label = `${this.solutions[0]}`;
      this.actionButtons[1].label = `${this.solutions[1]}`;
    },

    commitSolution(index: number) {
      if (this.isGameOver) return;
      this.results.push({
        id: this.results.length,
        info: `${this.task} = ${this.solutions[index]}`,
        value: this.solutions[index] === this.task.solution,
      });
      if (this.actionButtons[index].actionCounter >= 0) {
        this.actionButtons[index].actionCounter += 1;
      } else {
        this.actionButtons[index].actionCounter = 0;
      }
      this.nextTask();
    },
  },

  computed: {
    scoreElements(): ScoreElement[] {
      let score = 0;
      let scoreElements = [];
      this.results.forEach((res) => {
        score += res.value ? 1 : 0;
      });

      scoreElements.push({
        id: 0,
        info: "Solved tasks",
        value: score,
      });

      score = 0;

      this.results.forEach((res) => {
        score += !res.value ? 1 : 0;
      });

      scoreElements.push({
        id: 1,
        info: "Failed tasks",
        value: -score,
      });

      return scoreElements;
    },
  },

  watch: {
    gameCountdown: {
      deep: true,
      handler(newVal) {
        if (newVal.isOver) {
          this.endGame();
        }
      },
    },
  },
});
